import { apiAxiosInstance } from '../axiosInstance'
import { razorpayxRoutes } from '../route'

const link = () => {
  return apiAxiosInstance.post(razorpayxRoutes.link())
}

const check = () => {
  return apiAxiosInstance.get(razorpayxRoutes.check())
}

export const razorpayxApi = {
  link,
  check
}
